<template>

	<a-card :bordered="false" class="card-info">
		<a-row type="flex" style="align-items: center;">
			<a-col class="col-content" :span="24" :xl="12">
				<div class="card-content">
                    <template v-if="addressLang == 'cn'">
                        <h5>{{ $t('info_18') }}</h5>
                        <p><b>收货人：</b>{{storeAddr.addr_name}}</p>
                        <p><b>联系电话：</b>{{storeAddr.phone}}</p>
                        <p><b>地址： </b>{{storeAddr.addr}}</p>
                        <p><b>唛头：</b>{{ this.$store.state.memberInfo.member_sn }}</p>
                    </template>

                    <template v-else>
                        <h5>{{ $t('info_18') }}</h5>
                        <p><b>Consignee：</b>{{storeAddr.addr_name_en}}</p>
                        <p><b>Contact Number：</b>{{storeAddr.phone}}</p>
                        <p><b>Address： </b>{{storeAddr.addr_en}}</p>
                        <p><b>Shippinging Mark：</b>{{ this.$store.state.memberInfo.member_sn }}</p>
                    </template>
				</div>
                
				<div class="card-footer">
					<a href="#" size="small">
                        <a-button type="primary" @click="onCopy">{{ $t('info_19') }}</a-button>
						<span @click="onShowTip">{{ $t('info_20') }}</span>
						<!-- <svg width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path fill-rule="evenodd" clip-rule="evenodd" d="M7.29289 14.7071C6.90237 14.3166 6.90237 13.6834 7.29289 13.2929L10.5858 10L7.29289 6.70711C6.90237 6.31658 6.90237 5.68342 7.29289 5.29289C7.68342 4.90237 8.31658 4.90237 8.70711 5.29289L12.7071 9.29289C13.0976 9.68342 13.0976 10.3166 12.7071 10.7071L8.70711 14.7071C8.31658 15.0976 7.68342 15.0976 7.29289 14.7071Z" fill="#111827"/>
						</svg> -->
					</a>
				</div>
                <div class="lang">
                    <div class="link" :class="{active: addressLang == 'en'}" @click="addressLang = 'en'">EN</div>
                    <div class="separate">/</div>
                    <div class="link" :class="{active: addressLang == 'cn'}" @click="addressLang = 'cn'">CN</div>
                </div>
			</a-col>
			<a-col class="col-img" :span="24" :xl="12">
				<div class="card-img-bg">
					<img v-lazy="$STATIC_URL + '/info-card-1.png'" alt="">
				</div>
			</a-col>
		</a-row>
	</a-card>

</template>

<script>
    import useClipboard from 'vue-clipboard3'
    const {toClipboard} = useClipboard();
	export default ({
        props: {
            storeAddr: '',
        },
		data() {
			return {
                addressLang: 'en'
			}
		},
        methods: {
            async onCopy() {
                try {
                    let addr = '';
                    if(this.addressLang == 'cn') {
                        addr = `收件人: ${this.storeAddr.addr_name} 电话: ${this.storeAddr.phone}\n地址: ${this.storeAddr.addr} -- ${this.$store.state.memberInfo.member_sn}`;
                    }else {
                        addr = `Receipt: ${this.storeAddr.addr_name_en} Phone: ${this.storeAddr.phone}\nAddress: ${this.storeAddr.addr_en} -- ${this.$store.state.memberInfo.member_sn}`;
                    }

                    await toClipboard(addr);
                    this.$message.success('Copy successful!')
                } catch {
                    this.$message.error('Copy failed!')
                }
            },

            onShowTip() {
                this.$info({
                    title: this.$t('info_21'),
                    content: this.$t('info_22'),
                })
            }
        }
	})

</script>

<style lang="scss">
    .col-content {
        padding-left: 10px;
        padding-bottom: 24px;
        position: relative;
        h6 {
            color: #141414;
        }

        .lang {
            position: absolute;
            right: 0;
            display: flex;
            align-items: center;
            font-size: 14px;
            color: rgba(0, 0, 0, 0.45);
            line-height: 1.5;
            .link {
                cursor: pointer;
                &.active {
                    color: #141414 !important;
                }
            }
            .separate {
                margin: 0 8px;
            }
        }
    }

    .card-content {
        margin-bottom: 16px;
        p {
            margin-bottom: 0;
            font-size: 14px !important;
            line-height: 28px;
            color: #666;
            display: flex;
            align-items: flex-start;
            b {
                width: 190px;
                display: inline-block;
                flex: none;
            }
        }
    }
</style>